import {
    EDIT_CITY_FAILED,
    EDIT_CITY_LOADING,
    EDIT_CITY_SUCCESS,
  } from "../types";
  
  const initialState = {
    loading: false,
    error: null,
    status: null,
  };
  
  export const editCityReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
  ) => {
    switch (action.type) {
      case EDIT_CITY_LOADING:
        return {
          ...state,
          loading: action.loading,
          error: null,
          status: null,
        };
      case EDIT_CITY_SUCCESS:
        return {
          ...state,
          loading: false,
          status: action.payload,
        };
      case EDIT_CITY_FAILED:
        return {
          ...state,
          loading: false,
          error: action.error,
          status: null,
        };
     
      default:
        return state;
    }
  };
  